import {
  ArticleCategoryEnum,
  ArticleTypeEnum,
  IndexPageType,
} from 'service/article';

const productIndex: IndexPageType = {
  highlight: {
    id: 'interview-kabuzaru',
    title: '投資は「才能」ではなく「習慣」で勝つ',
    excerpt: `「仮説と思考の積み重ね」が資産を育てる`,
    category: ArticleCategoryEnum.Creator,
    date: '2025年12月18日',
    thumbnail: 'https://assets.postprime.com/internals/kabuzaru-profile.jpg',
    href: '/about/creator/interview-kabuzaru',
    type: ArticleTypeEnum.ForCreator,
    imageHeight: 360,
    imageWidth: 360,
  },
  articles: [
    {
      id: 'interview-matt',
      title: '「こわい」を無くす資産形成',
      excerpt: `思考をとめない 自分に合った資産形成`,
      category: ArticleCategoryEnum.Creator,
      date: '2025年11月18日',
      thumbnail: 'https://assets.postprime.com/internals/matt-profile.jpg',
      href: '/about/creator/interview-matt',
      type: ArticleTypeEnum.ForCreator,
    },
    {
      id: 'interview-kuu-chan',
      title: '「投資は簡単ではない、だから面白い」くーちゃんインタビュー',
      excerpt: `投資に出会い、しのぎを削る中で得た投資の掟。`,
      category: ArticleCategoryEnum.Creator,
      date: '2025年10月8日',
      thumbnail: 'https://assets.postprime.com/internals/kuuchan-profile.jpg',
      href: '/about/creator/interview-kuu-chan',
      type: ArticleTypeEnum.ForCreator,
    },
  ],
};

export default productIndex;
